import { apiMutate } from 'service/utils/mutation';

import { useDeliveryZoneMsToken } from 'hooks';
import { DeleteBulkDeliveryZonesInput, DeleteBulkDeliveryZonesPayload } from '../../types/generated';
import { deleteBulkDeliveryZonesMutation } from '../../mutations';

type useDeleteBulkDeliveryZoneType = () => ({
  input,
}: {
  input?: DeleteBulkDeliveryZonesInput;
}) => Promise<void | Partial<DeleteBulkDeliveryZonesPayload> | { hasError: boolean }>;

const useDeleteBulkDeliveryZone: useDeleteBulkDeliveryZoneType = () => {
  const deliveryZoneMsToken = useDeliveryZoneMsToken();
  return input =>
    apiMutate({
      mutation: deleteBulkDeliveryZonesMutation,
      variables: { input },
      requestHeaders: { token: deliveryZoneMsToken },
      handler: (res: any) => res,
    });
};

export default useDeleteBulkDeliveryZone;
